import { ChangeDetectorRef, Component, Injectable, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { SortDirection } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { CommentsService } from '../../service/comments.service';
import { LocalStorageService } from '../../service/local-storage-service.service';
import { SettingsService } from '../../service/settings.service';
import { UsersService } from '../../service/users.service';
import { deepCopy, formatRoleName, getRoleAbbreviation, getRoleColor, isDateTimeGetTimeSeconds, removeUndefined } from 'na-lib';
import { CreateUserDialogComponent } from '../create-user-dialog/create-user-dialog.component';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { InfoMesageDialogComponent } from '../../info-mesage-dialog/info-mesage-dialog.component';
import { AuthService } from '../../service/auth.service';
import { UsersEditDialogComponent } from '../users-edit-dialog/users-edit-dialog.component';
import { environment } from 'src/environments/environment';
import { DeleteConfirmationDialogComponent } from '../../delete-confirmation-dialog/delete-confirmation-dialog.component';
import { UserGroupEditDialogComponent } from '../user-group-edit-dialog/user-group-edit-dialog.component';
import { UserGroupService } from '../../service/user-group.service';

@Injectable()
export class MyCustomPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();
  constructor(private translate: TranslateService){}

  firstPageLabel = this.translate.instant("first_page");
  itemsPerPageLabel = this.translate.instant("items_page");
  lastPageLabel =this.translate.instant("last_page")
  nextPageLabel = this.translate.instant("next_page");
  previousPageLabel = this.translate.instant("previous_page");

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return this.translate.instant("page1_1");
    }
    const amountPages = Math.ceil(length / pageSize);
    return this.translate.instant("page_of_1") + (page + 1) +this.translate.instant("page_of_2") + amountPages;
  }
}

@Component({
    selector: 'app-manage-users-usergroups',
    templateUrl: './manage-users-usergroups.component.html',
    styleUrl: './manage-users-usergroups.component.css',
    providers: [{ provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }],
    standalone: false
})

export class ManageUsersUsergroupsComponent {
  userGroupsUserRights_create:any
  userGroupsUserRights_update:any
  userGroupsUserRights_delete:any
  usersUserRights_create:any
  usersUserRights_update:any
  usersUserRights_delete:any

  allGroups:any = []
  emptyList = false
  displayedColumnsGroups: string[] = ['displayName','creationDate', 'timeStamp','actions'];

  displayedColumnsUsers: string[] = ['displayName', 'email', 'creationDate', 'roles', 'status', 'actions'];
  dataSourceUsers = new MatTableDataSource([])
  dataSourceUsersGroups = new MatTableDataSource([])
  @ViewChild('paginatorGroups') paginatorGroups: MatPaginator;
  @ViewChild('sortGroups') sortGroups: MatSort;

  @ViewChild('sortUsers') sort!: MatSort;
  @ViewChild('paginatorUsers') paginator!: MatPaginator;

  paginatorSize = this.settingsService.paginator$
  sortActive:string="timeStamp"
  sortDirection:SortDirection='desc'
  userLength: number = 0;
  userGroupsList:any = []
  hideDefaultRole:boolean
  hostName:any = environment.firebase.projectId
  groupsSpinner = true
  usersOfMyContext:any
  constructor(private settingsService: SettingsService,
    private commentService: CommentsService,
    private translate: TranslateService,
    private functions: Functions,
    private authService: AuthService,
    public dialog: MatDialog,
    private localStorageService:LocalStorageService,
    private changeDetectorRef: ChangeDetectorRef,
    private usGroupService: UserGroupService,
    private userService: UsersService){
      this.commentService.progressSpin.emit(true)
      this.userService.getListOfUsersWithContext()
      this.hideDefaultRole = this.hostName === 'narravero-eu-prod';

    }

  ngOnInit():void{
    this.usersUserRights_create = this.settingsService.modulesRolesRights$.value['users']['C']
    this.usersUserRights_delete = this.settingsService.modulesRolesRights$.value['users']['D']
    this.usersUserRights_update= this.settingsService.modulesRolesRights$.value['users']['U']

    this.settingsService.modulesRolesRights$.subscribe( value => {
      this.usersUserRights_create = this.settingsService.modulesRolesRights$.value['users']['C']
      this.userGroupsUserRights_create = this.settingsService.modulesRolesRights$.value['users']['C']
    })

    this.userGroupsUserRights_update = this.settingsService.userRolesRights$['users']['U']
    this.userGroupsUserRights_create = this.settingsService.userRolesRights$['users']['C']
    this.userGroupsUserRights_delete = this.settingsService.userRolesRights$['users']['D']

    if(!this.userGroupsUserRights_create)
      document.getElementById('btn-create').style.color="#e0e0e0"

    this.getUserGroups()

    this.userService.usersWithcontextId$.subscribe(users => {
      if(users){
        const data = deepCopy(users)
        this.filterUsersList(data)
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceUsers.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceUsers.paginator) {
      this.dataSourceUsers.paginator.firstPage();
    }
  }

  getUserGroups(){
    try{
      this.groupsSpinner = true
      this.usGroupService.observeContextsUserGroupsFirestoreWithId().subscribe( value => {
        this.allGroups = value
        this.dataSourceUsersGroups = new MatTableDataSource<any>(this.allGroups);

        this.dataSourceUsersGroups.paginator = this.paginatorGroups;
        this.dataSourceUsersGroups.sort = this.sortGroups;
        if(this.allGroups.length==0)
          this.emptyList=true

        this.groupsSpinner = false
        this.loadTablePreferences()
      })

    }catch(error){
      console.log(error)
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.LOAD_FAILED")
      this.commentService.addSnackBar.emit(message)
    }
  }

  filterUsersList(data){
    if(data){
      const filteredUsers = data
      const list = deepCopy(filteredUsers)
      this.usersOfMyContext = filteredUsers
      list.sort( (a,b) => { return a?.displayName?.toLowerCase().localeCompare(b?.displayName?.toLowerCase());})
      this.dataSourceUsers.data = list.map(user => ({
        ...user,
        timeStamp: user.timeStamp ? isDateTimeGetTimeSeconds(user.timeStamp) : undefined,
        creationDate: user.creationDate ? isDateTimeGetTimeSeconds(user.creationDate) : undefined
      }));

      // Ensure that the length of the dataSource is updated
      this.userLength = this.dataSourceUsers.data.length;
      this.dataSourceUsers.sort = this.sort;
      this.dataSourceUsers.paginator = this.paginator;
      this.dataSourceUsers.paginator?.firstPage()
      this.commentService.progressSpin.emit(false)
    }
    // else
    // this.commentService.progressSpin.emit(false)
  }

  openDialogCreateUser() {
    let dialogRef = this.dialog.open(CreateUserDialogComponent, {
      data: { userGroupsList: this.userGroupsList }
    });
    dialogRef.afterClosed().subscribe(async (result: any) => {
      if(result[0])
      this.userService.getListOfUsersWithContext()
    });
  }

  getUserRoles(user: any): string[] {
    const contextId = this.settingsService.contextId$
    // If rolesPerContext exists and has roles for currentContext, use it
    if (user.rolesPerContext && user.rolesPerContext[contextId]?.length)
      return user.rolesPerContext[contextId];
    // Otherwise fallback to roles
    return user.roles || [];
  }

  resetPassword(email:any){
    if(email){
      this.commentService.progressSpin.emit(true)
      this.authService.initResetPassword(email).then( () => {
          this.commentService.progressSpin.emit(false)
          const message = this.translate.instant("SnackBarConstants.RESET_PASSWORD_MAIL_OK")
          this.commentService.addSnackBar.emit(message)
          let dialogRef= this.dialog.open(InfoMesageDialogComponent, {
            data: {
                values: {
                message: 'PASSWORD_RESET_MAIL_OK',
                mail: email
              }
            },
          });
          dialogRef.afterClosed().subscribe(result => {});
        },
        (rejectionReason) => {
          console.log(rejectionReason)
          this.commentService.progressSpin.emit(false)
        }
      ).catch( e => {
        console.log(e)
        const message = this.translate.instant("SnackBarConstants.RESET_PASSWORD_MAIL_FAILED")
        this.commentService.addSnackBar.emit(message)
        this.commentService.progressSpin.emit(false)
      })
    }else{
      const message = this.translate.instant("SnackBarConstants.RESET_PASSWORD_MAIL_FAILED")
      this.commentService.addSnackBar.emit(message)
    }
  }

  reinviteUser(user: any) {
    this.commentService.progressSpin.emit(true);
    const resendInvite = httpsCallable(this.functions, 'admin-resendInvite');

    resendInvite({
      contextId: user.contextId,
      displayName: user.displayName,
      email: user.email
    })
    .then((result) => {
      this.commentService.progressSpin.emit(false);
      const message = this.translate.instant("SnackBarConstants.USER_REINVITE_OK");
      this.commentService.addSnackBar.emit(message);
    })
    .catch((error) => {
      console.error('Error: Failed to resend the user invitation', error);
      this.commentService.progressSpin.emit(false);
      const message = this.translate.instant("SnackBarConstants.USER_REINVITE_FAILED");
      this.commentService.addSnackBar.emit(message);
    });
  }

  editUser(user: any): void {
    let dialogRef = this.dialog.open(UsersEditDialogComponent, {
      data: {
        userGroupsList: this.allGroups,
        userToEdit: user,
        loggedUser: this.settingsService.userAccount$
      },
      panelClass: 'custom-dialog-container',
      position: { right: '0' },
      enterAnimationDuration: '200ms',
      exitAnimationDuration: '200ms'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result[0]) {
        const updatedUser = user
          updatedUser.displayName= result[1].displayName
          const groupsPerContext = result[1].groupsPerContext
          updatedUser.groupsPerContext = groupsPerContext?.length!=0 ? groupsPerContext : undefined
          removeUndefined(updatedUser)
        if(Object.keys(result[1].rolesPerContext )?.length!=0)
          updatedUser.rolesPerContext= result[1].rolesPerContext

        this.userService.updateUserData( user.id, updatedUser).subscribe( value => {
          const updatedUser = value.updatedData
          this.dataSourceUsers.data = this.dataSourceUsers.data.map(u => {
            if (u.id === user.id)
              return { ...u, ...updatedUser };

            return u;
          });

          this.userService.updateListAfterUpdate(this.dataSourceUsers.data)
          this.commentService.progressSpin.emit(false)
        })
      }
    });
  }

  getRoleAbbreviation(role){
    return getRoleAbbreviation(role)
  }

  getRoleColor( role){
   return getRoleColor(this.hideDefaultRole, role)
  }

  formatRoleName( role){
    return formatRoleName(role)
  }

  addGroup(){
    let dialogRef = this.dialog.open(UserGroupEditDialogComponent, {
      data:undefined,
    });

    dialogRef.afterClosed().subscribe(value => {
      if(value[0]){
        const message = this.translate.instant("SnackBarConstants.CREATE_OK")
        this.commentService.addSnackBar.emit(message)
        this.getUserGroups()
      }
    });
  }

  editGroup(group){
    let dialogRef = this.dialog.open(UserGroupEditDialogComponent, {
      data:group
    });

    dialogRef.afterClosed().subscribe(value => {
      if(value[0]){
        this.getUserGroups()
        const message = this.translate.instant("SnackBarConstants.UPDATE_OK")
        this.commentService.addSnackBar.emit(message)
      }
    });
  }

  deleteGroup(group){
    let dialogRef= this.dialog.open(DeleteConfirmationDialogComponent, {
      data: {
        values:group,
        type:"UserGroup"
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        this.commentService.progressSpin.emit(false)
        const message = this.translate.instant("SnackBarConstants.DELETE_OK")
        this.commentService.addSnackBar.emit(message)
        this.getUserGroups()
      }else{
        this.commentService.progressSpin.emit(false)
        const message = this.translate.instant("SnackBarConstants.DELETE_DISMISS")
        this.commentService.addSnackBar.emit(message)
      }
    });
  }

  storeTablePreferences(): void {
    const preferences = {
      pageSize: this.paginatorGroups.pageSize,
      sortActive: this.sortGroups.active,
      sortDirection: this.sortGroups.direction,
      pageIndex: this.paginatorGroups.pageIndex
    }

    if(preferences.sortDirection==='' && preferences.sortActive != 'timeStamp'){
      this.sortGroups.active = 'timeStamp'
      this.sortGroups.direction = 'desc'
      preferences.sortActive = 'timeStamp'
      preferences.sortDirection as SortDirection == 'desc'
    }

    this.sortActive = preferences.sortActive
    this.sortDirection = preferences.sortDirection as SortDirection
    this.localStorageService.set('userGroupsTablePreferences', preferences);
  }

  isDateTimeSeconds(date){
    return isDateTimeGetTimeSeconds(date)
  }

  ngAfterViewInit(): void {
    this.dataSourceUsersGroups.paginator = this.paginatorGroups;
    this.dataSourceUsersGroups.sort = this.sortGroups;
    this.loadTablePreferences();
  }

  loadTablePreferences(): void {
    const preferences = this.localStorageService.get('userGroupsTablePreferences');
    this.changeDetectorRef.detectChanges();
  }

   deleteUser(user: any) {

      let dialogRef= this.dialog.open(DeleteConfirmationDialogComponent, {
        data: {
          user:user.displayName,
          type:'Users'
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result[0]) {
          this.commentService.progressSpin.emit(true);

          const userUID = user.id;
          const contextId = this.settingsService.contextId$
          const deleteUser = httpsCallable(this.functions, 'admin-deleteUser');

          deleteUser({ uid: userUID, contextId: contextId })
            .then((result) => {

              this.dataSourceUsers.data = this.dataSourceUsers.data.filter(u => u.id !== userUID);

              this.commentService.progressSpin.emit(false);
              const message = this.translate.instant("SnackBarConstants.USER_DELETE_OK");
              this.commentService.addSnackBar.emit(message);
            })
            .catch((error) => {
              console.error('Error deleting user:', error);
              this.commentService.progressSpin.emit(false);
              const message = this.translate.instant("SnackBarConstants.USER_DELETE_FAILED");
              this.commentService.addSnackBar.emit(message);
            });
        } else {
          const message = this.translate.instant("SnackBarConstants.DELETE_DISMISS");
          this.commentService.addSnackBar.emit(message);
        }

      });

  }

  getUsersForGroup(groupId: string) {
    return this.usersOfMyContext?.filter( user => (user.groupsPerContext && user.groupsPerContext[this.settingsService.contextId$]) ? user.groupsPerContext[this.settingsService.contextId$].includes(groupId) : false)
  }
}